import en from './assets/i18n/en';

export const translations = {
  'en-US': en,
};
